import { Trans } from "@lingui/react/macro";

export function EnabledDisabled({ value, colored = false }: { value: boolean; colored?: boolean }) {
    const label = value ? <Trans>Enabled</Trans> : <Trans>Disabled</Trans>;

    return <span className={colored ? (value ? "text-success" : "text-muted") : undefined}>{label}</span>;
}
